/* eslint-disable react/prop-types */
import locationIcon from '../../../common/images/revamp/icon/location.svg';
import { useDispatch, useSelector } from 'react-redux';
import { isEmptyData } from '../../../utils/helper';
import { setUser } from '../../../store/reducers/user';

const Recent = (props) => {
	const { onClose } = props;
	const dispatch = useDispatch();

	const { recentData } = useSelector((state) => state.location);
	const user = useSelector((state) => state.user);

	const handleClick = (data = null) => {
		if (isEmptyData(data?.latitude) || isEmptyData(data?.longitude)) return;
		dispatch(
			setUser({
				addressName: null,
				address: data?.address,
				city: data?.city,
				district: data?.district,
				village: data?.village,
				state: data?.state,
				postalCode: data?.postalCode ?? '',
				latitude: Number(data?.latitude),
				longitude: Number(data?.longitude),
				detail: data?.detail || user?.detail || null,
				firstName: data?.firstName || user?.firstName || null,
				lastName: data?.lastName || user?.lastName || null,
				email: data?.email || user?.email || null,
				primary_phone: data?.phone || user?.primary_phone || null,
			}),
		);
		onClose?.();
	};

	if (isEmptyData(recentData)) return null;

	return (
		<div className='max-h-80 mb-4'>
			<p className='text-[var(--dark-gray)] font-semibold text-sm mb-4'>Recent</p>
			<div className='space-y-2.5'>
				{recentData?.map((location, index) => (
					<div key={index} id='search_address_recent_location' className='[&:not(:last-child)]:border-b border-solid border-[var(--pin-ball)] p-2.5 flex items-center gap-2.5' onClick={() => handleClick(location)}>
						<img src={locationIcon} alt='location' className='w-4.5 h-4.5' />
						<div className='space-y-0.5'>
							<p className='text-[var(--dark-gray)] text-xxs'>{location.address}</p>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default Recent;
